module.exports = __webpack_public_path__ + "06224a7d.svg";